__webpack_require__.p = "/sproj-examples/examples/create-alignment/";